import { PageHeader } from 'antd';
import * as queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { RequestLogList, RequestLogListSearchFilters } from '../../components/LogsView';
import ClientController from '../../controllers/client.controller';
import LogsController from '../../controllers/logs.controller';
import { Client } from '../../types/Client';
import { RequestsLog } from '../../types/RequestLog';

const LogsListContainer = ({
    history,
    match: { url },
    location: { search },
}: RouteComponentProps): React.ReactElement => {
    const [componentStatusFlags, setComponentStatusFlags] = useState<{
        isLoadingLogs: boolean;
        isLoadingClients: boolean;
    }>({
        isLoadingLogs: true,
        isLoadingClients: true,
    });

    const [appliedFilters, setAppliedFilters] = useState<any>(queryString.parse(search, { arrayFormat: 'bracket' }));
    const [clients, setClients] = useState<Client[]>([]);

    const [data, setData] = useState<{
        requestLogs: RequestsLog[];
        pagination: any;
    }>({
        requestLogs: [],
        pagination: {},
    });

    const setFiltersToApply = (filters: any, opts?: { isPaging: boolean }): void => {
        setAppliedFilters((prevAppliedFilters: any) => {
            const filterResult = opts && opts.isPaging ? { ...prevAppliedFilters, ...filters } : { ...filters };
            const query = queryString.stringify(filterResult, { arrayFormat: 'bracket' });
            history.push(`${url}?${query}`);
            return filterResult;
        });
    };

    const getRequestLogs = async (): Promise<void> => {
        try {
            setComponentStatusFlags((prevState) => ({ ...prevState, isLoadingLogs: true }));
            const {
                data: requestLogs,
                _metadata: { pagination },
            } = await LogsController.getAllRequestLogs(appliedFilters);
            setData({
                requestLogs,
                pagination,
            });
        } finally {
            setComponentStatusFlags((prevState) => ({ ...prevState, isLoadingLogs: false }));
        }
    };

    const getAllClients = async (): Promise<void> => {
        try {
            setComponentStatusFlags((prevState) => ({ ...prevState, isLoadingClients: true }));
            const { list: clientList } = await ClientController.getAllClients(undefined, -1);
            setClients(clientList);
        } finally {
            setComponentStatusFlags((prevState) => ({ ...prevState, isLoadingClients: false }));
        }
    };

    useEffect(() => {
        getRequestLogs();
        getAllClients();
    }, [appliedFilters]);

    return (
        <div className="shadow-sm">
            <PageHeader
                className="site-page-header py-2 justify-content-end"
                title={<p className="h5 m-0">Requests</p>}
            />
            <RequestLogListSearchFilters
                onSetSearchFilters={setFiltersToApply}
                initialFilters={appliedFilters}
                isLoadingData={componentStatusFlags.isLoadingLogs && componentStatusFlags.isLoadingClients}
                clients={clients}
            />
            <RequestLogList
                requestLogs={data.requestLogs}
                pagination={data.pagination}
                onPageChanges={setFiltersToApply}
                isLoadingData={componentStatusFlags.isLoadingLogs && componentStatusFlags.isLoadingClients}
                clients={clients}
            />
        </div>
    );
};

export default LogsListContainer;
